import zh_CN from '../locale/zh_CN'
import en_US from '../locale/en_US'
import { loadLanguage } from 'Utils/jwtUtil';

export function T(key, params) {
    let lang = loadLanguage();
    if(lang && lang === 'EN'){
        window.languageData = en_US || {};
    } else {
        window.languageData = zh_CN || {};
    }
        
    let result = window.languageData.hasOwnProperty(key) ? window.languageData[key] : key;
    let temp;

    // if (params) {

    //     var regExp = new RegExp();

    //     params.forEach((param, key) => {
    //         regExp = eval('/{:' + key + '}/g');
    //         result = result.replace(regExp, param);
    //     });
    // }

    if (params) {

        var regExp = new RegExp();

        params && params.forEach((param, key) => {
            regExp = '{' + key + '}';
            temp = param !== null && param !== undefined ? param : ''
            result = result.replace(regExp, temp);
        });
    }

    return result
}
